class PriceComponent extends HTMLElement {
  constructor() {
    super();
    this.setupFeeBase = 0;
    this.minQuantity = parseInt(this.dataset.minQuantity) || 1;

    this.totalPriceElement = this.querySelector('[data-total-price]');
    this.unitPriceElement = this.querySelector('[data-unit-price]');
    this.setupFeeElement = this.querySelector('[data-setup-fee]');

    this.currentQuantity = this.minQuantity;
    this.frontInkPrice = 0;
    this.backInkPrice = 0;
    this.pocketInkPrice = 0;
    this.frontAdditionalPrice = 0;
    this.backAdditionalPrice = 0;
    this.pocketAdditionalPrice = 0;
  }

  connectedCallback() {
    this.bindEvents();
    this.getPricingRange()
    this.initializeOptionPrices();
    this.updatePrices();
  }

  initializeOptionPrices() {
    const frontInkSelect = document.querySelector('[data-option-type="front-ink"] select');
    const backInkSelect = document.querySelector('[data-option-type="back-ink"] select');

    if (frontInkSelect) {
      this.frontInkPrice = this.getOptionPrice(frontInkSelect);
      this.frontAdditionalPrice = this.getAdditionalPrice(frontInkSelect);
    }

    if (backInkSelect) {
      this.backInkPrice = this.getOptionPrice(backInkSelect);
      this.backAdditionalPrice = this.getAdditionalPrice(backInkSelect);
    }

    const pocketInkSelect = document.querySelector('[data-option-type="pocket-ink"] select');
    if (pocketInkSelect) {
      this.pocketInkPrice = this.getOptionPrice(pocketInkSelect);
      this.pocketAdditionalPrice = this.getAdditionalPrice(pocketInkSelect);
    }
  }

  bindEvents() {
    document.addEventListener('quantity-changed', (event) => {
      let quantity = event.detail.quantity;
      if (isNaN(quantity) || quantity < this.minQuantity) {
        quantity = this.minQuantity;
      }
      this.currentQuantity = quantity;
      this.updatePrices();
    });

    document.addEventListener('change', (event) => {
      if (event.target.closest('[data-option-type="front-ink"]')) {
        const optionPrice = this.getOptionPrice(event.target);
        const additionalPrice = this.getAdditionalPrice(event.target);
        this.frontInkPrice = optionPrice;
        this.frontAdditionalPrice = additionalPrice;
        this.updatePrices();
      }
    });

    document.addEventListener('change', (event) => {
      if (event.target.closest('[data-option-type="back-ink"]')) {
        const optionPrice = this.getOptionPrice(event.target);
        const additionalPrice = this.getAdditionalPrice(event.target);
        this.backInkPrice = optionPrice;
        this.backAdditionalPrice = additionalPrice;
        this.updatePrices();
      }
    });

    document.addEventListener('change', (event) => {
      if (event.target.closest('[data-option-type="pocket-ink"]')) {
        const optionPrice = this.getOptionPrice(event.target);
        const additionalPrice = this.getAdditionalPrice(event.target);
        this.pocketInkPrice = optionPrice;
        this.pocketAdditionalPrice = additionalPrice;
        this.updatePrices();
      }
    });
  }

  getOptionPrice(selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const optionPrice = selectedOption.getAttribute('data-option-price');
    return parseFloat(optionPrice) || 0;
  }

  getAdditionalPrice(selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const additionalPrice = selectedOption.getAttribute('data-additional-color-price');
    return parseFloat(additionalPrice) || 0;
  }

  calculateSetupFee() {
    let totalSetupFee = this.setupFeeBase;

    totalSetupFee += this.frontInkPrice;
    totalSetupFee += this.backInkPrice;
    totalSetupFee += this.pocketInkPrice;

    return totalSetupFee;
  }

  calculateUnitPrice() {
    // Базовая цена в зависимости от количества
    let unitPrice = this.json["0-24"];

    for (const range in this.json) {
      const [min, max] = range.split('-').map(Number);
      if (this.currentQuantity >= min && (this.currentQuantity <= max || isNaN(max))) {
        unitPrice = this.json[range];
        break;
      }
    }

    unitPrice += this.frontAdditionalPrice;
    unitPrice += this.backAdditionalPrice;
    unitPrice += this.pocketAdditionalPrice;

    return unitPrice;
  }

  calculateTotalPrice() {
    const unitPrice = this.calculateUnitPrice();
    const setupFee = this.calculateSetupFee();

    return (unitPrice * this.currentQuantity) + setupFee;
  }

  formatMoney(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  updatePrices() {
    const totalPrice = this.calculateTotalPrice();
    const unitPrice = this.calculateUnitPrice();
    const setupFee = this.calculateSetupFee();

    if (this.totalPriceElement) {
      this.totalPriceElement.textContent = this.formatMoney(totalPrice);
    }

    if (this.unitPriceElement) {
      this.unitPriceElement.textContent = this.formatMoney(unitPrice);
    }

    if (this.setupFeeElement) {
      this.setupFeeElement.textContent = this.formatMoney(setupFee);
    }
    //
    // this.dispatchEvent(new CustomEvent('quantity-changed', {
    //   detail: {
    //     totalPrice,
    //     unitPrice,
    //     setupFee,
    //     quantity: this.currentQuantity
    //   },
    //   bubbles: true
    // }));
  }

  setQuantity(quantity) {
    this.currentQuantity = Math.max(this.minQuantity, quantity);
    this.updatePrices();
  }

  setInkColors(frontColors, backColors) {
    this.frontInkColors = frontColors || 0;
    this.backInkColors = backColors || 0;
    this.updatePrices();
  }

  getCurrentPrices() {
    return {
      totalPrice: this.calculateTotalPrice(),
      unitPrice: this.calculateUnitPrice(),
      setupFee: this.calculateSetupFee(),
      quantity: this.currentQuantity
    };
  }

  getPricingRange() {
      const jsonScript = this.querySelector("[data-product-pricing-group]");

      if (!jsonScript) {
          return null;
      }

      this.json = JSON.parse(jsonScript.innerHTML);
  }
}

customElements.define('price-component', PriceComponent);
